<template>
  <div class="component-name">
    <label class="tw-font-medium">AI Chat</label>

    <div @click="openChatModal">
      <SidebarButton
        :option="{icon: 'fas fa-robot', label: 'AI Chat', value: 'ai-chat'}"
        :is-selected="true"
        :show-checkmark="false"
      />
    </div>
    <o-modal
      :active.sync="isChatModalActive"
      trap-focus
      content-class="tw-min-w-[800px]"
    >
      <p class="tw-text-center tw-text-2xl tw-font-medium tw-mt-6">
        Ask a question about your analysis
      </p>
      <ChatbotWrapper
        class="tw-max-h-96 tw-p-12 tw-max-w-96"
        :is-disabled="checkupStore.portfolioHoldingsCount > 30"
        disabled-message="Chat is currently disabled for large portfolios. Coming soon!"
      />
    </o-modal>
  </div>
</template>

<script>
import SidebarButton from './SidebarButton.vue';
import ChatbotWrapper from '@frontend/ui/features/chat/components/ChatbotWrapper.vue';
import { useCheckupStore } from '@frontend/ui/stores/checkupStore';
import { mapStores } from 'pinia';

export default {
  name: 'ComponentName',
  components: { SidebarButton, ChatbotWrapper },
  data() {
    return {
      isChatModalActive: false,
    };
  },
  computed: {
    ...mapStores(useCheckupStore),
  },
  methods: {
    openChatModal() {
      console.log('openChatModal');
      this.isChatModalActive = true;
    },
  },
};
</script>

<style scoped>

</style>
